var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ez-user-modal',{ref:"userModal",attrs:{"formKey":_vm.formKey,"formAction":_vm.formAction,"user":_vm.user},on:{"close":_vm.reset,"success":_vm.onSubmitSuccess}},[_c('EzRolesList',{ref:"roles",attrs:{"group-id":_vm.groupId,"formKey":_vm.formKey,"user":_vm.user,"roles":_vm.roles,"venues":_vm.venues}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }